<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/school-desktop-banners/arni-school-of-aggriculture.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-agriculture.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-agriculture.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400  active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Specialization</a>
            <a href="#dean-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Dean's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Expert
                Faculty</a>
            <!--<a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>

        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Agriculture</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">The School of Agriculture at ARNI is dedicated to preparing the next
                generation of agricultural leaders and researchers who will lead the future of sustainable agriculture,
                rural development, and food security. Located in a region of significant biological and agricultural
                diversity, the school offers students the space to explore, experiment, and develop as professionals who
                are determined to make positive and meaningful changes that will better our agricultural systems and -
                more broadly - our world.
            </p>
            <p class="text-gray-500 text-justify">Our focus on traditional approaches and a broad experience in modern
                technologies continues to honor the deep history and current thinking about food production, soil
                health, food and climate systems, and crop management. Our students are cultivated through industry
                interactions and entrepreneurial skill development initiatives, fostering a culture of innovation and
                leadership.
            </p>
            <p class="text-gray-500 text-justify">At ARNI University, we blend classroom theory, practical learning
                experience, field research, and community-based projects. Whether it is organic farming or agri-tech
                apps and commercial activity, our students have the skills and knowledge necessary to address the global
                issues we face, such as food security and environmental protection. Our curriculum offers exposure to
                generate entrepreneurial thinking and innovation, understanding leadership, and ensuring that graduates
                can help shape India's agricultural future and beyond.
            </p>
            <p class="text-gray-500 text-justify">Our vision is simple: we want students to grow as professionals who
                understand the land, appreciate the environment, and promote sustainable development.</p>
            <p class="text-gray-500 text-justify my-2"><strong>Vision -</strong> Our vision is to become the leading
                center for excellence in agriculture education, including research-based learning and innovations. Our
                valuable students contribute to sustainable growth and food security.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission -</strong> We are on a mission to deliver
                comprehensive education that integrates theoretical knowledge with practical skills in agricultural
                science, which promotes eco-friendly and sustainable farming techniques to address global food
                challenges.
            </p>
        </div>

        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">ARNI University offers a comprehensive BSc Honors in agriculture at
                its ARNI School of Agriculture, focusing on innovation, education, and hands-on learning. Located in
                Indore, the university offers vast acres of agricultural fields for learning, demonstration, and
                research.
            </p>
            <p class="text-gray-500 text-justify">The curriculum is designed to align with industry needs, integrating
                classroom learning with hands-on experience. Students engage in year-round practical experiences,
                including Rural Agricultural Work Experience (RAWE) and Agro-Industrial Attachments, providing valuable
                exposure to real-world agricultural settings.
            </p>
            <!-- <ul class="list-disc">
                 <li class="text-gray-500 text-justify my-2">
                     Undergraduate Programs
                     <ul class="list-disc ml-6">
                         <li>B.Sc (Hons) Agriculture</li>
                     </ul>
                 </li>
             </ul>-->
            <p class="text-gray-500 text-justify"><strong>Scope:</strong> The School of Agriculture offers a wealth of
                opportunities for students to excel academically, professionally, and socially. The courses cover topics
                in agriculture and related fields like horticulture, soil science, plant breeding, and agricultural
                economics.
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">Students studying agriculture have a wide range of options,
                    including positions in the public and private sectors.
                </li>
                <li class="text-gray-500 text-justify my-2">Graduates can work in research and development, banking,
                    insurance, and education. Those with an agricultural degree are eligible to take several competitive
                    tests at the federal and state levels.
                </li>
                <li class="text-gray-500 text-justify my-2">Furthermore, it equips them to become self-sufficient
                    entrepreneurs who use their leadership, strategic, and analytical skills to build prosperous
                    professions.
                </li>
                <li class="text-gray-500 text-justify my-2">Graduates can join national and international research
                    institutes focusing on crop improvement, biotechnology, and sustainable agricultural practices.
                </li>
                <li class="text-gray-500 text-justify my-2">Many government bodies like ICAR, NABARD, and agriculture
                    departments regularly hire agriculture graduates for research, extension, and policy roles.
                </li>
                <li class="text-gray-500 text-justify my-2">They can further their studies by pursuing a master's and a
                    Ph.D.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">If you are dreaming of a career in the field of Agriculture
                Science and technologies or want to contribute to farming practices and food security, the ARNI School
                of Agriculture is the right place for a promising future. Join us now in cultivating a greener, more
                sustainable world.
            </p>
            <h4 class="text-xl font-bold mb-2">Career Opportunities</h4>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"><span class="font-semibold">Agricultural Officer or Agronomist -</span>
                    To improve food production, Agricultural Officers and agronomists play crucial roles in agriculture,
                    promoting modern farming techniques and supporting farmers.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Agri-Business Manager or Consultant -</span>
                    Agri-business professionals with farming and management skills are required for management roles,
                    blending agriculture with entrepreneurship and strategic thinking.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold"> Soil Scientist or Crop Specialist -</span>
                    Soil Scientists or Crop Specialists analyze soil properties, suggest fertilization, improve seed
                    varieties, and conduct field trials, often working in research institutions or government labs.
                </li>
                <li class="text-gray-500 my-2"><span
                    class="font-semibold">Researcher in Government or Private Labs -</span> Graduates in agriculture can
                    pursue research roles in reputable bodies like ICAR, CSIR, or private labs, focusing on pest
                    control, climate-resilient crops, and organic farming techniques.
                </li>
            </ul>

            <h2 class="text-xl font-bold mb-2">Arni University’s Contribution to Emerging Technologies</h2>
            <p class="text-gray-500 my-2">At ARNI University, we believe that agriculture is not only a subject, but a
                mission to feed and nourish the world we live in. Our School of Agriculture emphasizes a blend of
                academic excellence and practical exposure to develop a positive, real world impact. Our world-class
                laboratories, model farms, and industry collaborations help ensure students benefit from practical
                learning.
            </p>
            <p class="text-gray-500 my-2">Students are constantly encouraged to engage in agricultural seminars,
                farmer-student interaction programs, and collaborative research activities to sharpen their innovation
                skills and their knowledge. In addition, we advocate for students to gain on-the-job learning
                experiences by engaging in internships with agro-industries and government research bodies to gain
                first-hand experiences of dealing with real-time problems in agriculture and agri-food systems.
            </p>
            <p class="text-gray-500 my-2">ARNI is a platform where we prepare professionals who are career-ready and
                socially responsible change agents in the agriculture sector.
            </p>

            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2">With the combination of traditional knowledge and emerging agri-tech
                    advancements, our focus is to ensure a comprehensive curriculum with practical exposure to equip
                    students with industry-relevant education.
                </li>
                <li class="text-gray-500 my-2">We are committed to providing the best education. Therefore, we bring
                    expert faculty and mentors who not only educate students with textbook knowledge but also guide them
                    to real-world success.
                </li>
                <li class="text-gray-500 my-2"> We offer hands-on learning experiences by offering live farming
                    projects, our approach ensures you don’t just learn agriculture—you live it.
                </li>
                <li class="text-gray-500 my-2"> Collaborations with agri-industries, government departments, and NGOs
                    for internships, placements, and research.
                </li>
                <li class="text-gray-500 my-2"> Our dedicated team ensures students land jobs in top organizations
                    across
                    the agri and development sector.
                </li>
                <li class="text-gray-500 my-2"> Our vision is to make education accessible to all. We offer affordable
                    courses, scholarships, and other financial assistance to the students.
                </li>
            </ul>

            <p class="my-2 text-gray-500 font-semibold">Suppose you are dreaming of a career in the field of
                Agricultural Science and technologies or want to contribute to farming practices and food security. In
                that case, the ARNI School of Agriculture is the right place for a promising future. Join us now in
                cultivating a greener, more sustainable world.
            </p>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Agriculture Disciplines & Specializations</h2>
            <div class="flex justify-center">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-6 w-full md:w-[25%]">
                    <div
                        *ngFor="let department of departments"
                        class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                    >
                        <div class="flex items-center mb-4">
                            <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                            <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                        </div>
                        <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                            <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                                <li class="text-md">{{ department.branch }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="dean-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img
                    src="assets/img/dean-as-per-schools/dr-jay-prakash-thakur-arni-school-of-agriculture-and-life-sciences.png"
                    alt="Dean" class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Jay Prakash Thakur
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto">
                <h2 class="text-2xl font-bold mb-2">Dean’s Message</h2>
                <p class="text-gray-700 text-justify">
                    I feel very proud to write this message as the Dean of ARNI School of Agriculture on behalf of each
                    faculty member who gives their best to shape the future of our students and transform them into
                    valuable assets for society!
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    School of Agriculture, a constituent part of ARNI University, offers a conducive teaching and
                    learning environment with the best ideal infrastructure and modern facilities for providing quality
                    education since its inception by aiming to make our students noble human beings and successful
                    professionals in their fields.
                </p>
                <p class="text-gray-700 mt-4 text-justify">Through our BSC in Agriculture program, we trained students
                    to meet the demands of stakeholders and farmers for sustainable agriculture following the modern
                    challenges and solutions.
                </p>
                <p class="text-gray-700 mt-4 text-justify">In wrapping up, I would like to welcome young minds to join
                    our community of Agro-experts. Come join us in maintaining the ideals we hold as a top-notch
                    educational institution that cultivates a polite, encouraging, and accepting atmosphere. </p>
                <p class="text-gray-700 mt-4 text-justify">Wishing you a successful future!</p>
                <p class="text-gray-700 mt-4 text-justify font-bold">Dr. Jay Prakash Thakur</p>
                <p class="text-gray-700 mt-4 text-justify">Dean, ARNI School of Agriculture</p>
                <p class="text-gray-700 mt-4 text-justify">ARNI University</p>
            </div>
        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-40 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!-- <p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div id="expert-faculty" class="w-full">
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-6xl overflow-hidden">
                    <div
                        class="flex transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px] w-full">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>
                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('about/faculty')">
                    View All Faculty
                </button>
            </div>
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="flex flex-col items-center p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                            (click)="goTo('/about/faculty')">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

     <!--   <div id="testimonials" class="py-16 bg-white font-montserrat">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;        <p class="font-bold text-[#012E26]">
                                                                Placed In:
                                                                <span class="text-[#00BFA5]">
                                  {{ testimonial.company }}
                                </span>
                                                            </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
